export enum vPasswordEnum {
    Length,
    Upper,
    Lower,
    Number,
    SpecialChar,
    ConfirmPassword,
    ComparePassword
}
export class vPasswordConst{
    public static readonly PASS_DESCRIPTION:string = 'Características para elegir la contraseña: Deberá tener al menos 12 caracteres, dentro de esto deberá haber por lo menos una letra mayúscula, una minúscula, un número y un caracter especial.';
    public static readonly AUX_TEXT_TO_REPLACE:string = '{message}';
    public static readonly CHANGE_PASS_FORM: string = `
<h5 style="color: rgb(189, 45, 45);">${vPasswordConst.AUX_TEXT_TO_REPLACE}</h5>
<div style="margin-bottom: 10px;">
  <label for="password" style="display: block; text-align: left;">
    Nueva Contraseña
    <span class="info-icon">
      <svg width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
        <path d="M8 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-13a6 6 0 1 1 0 12A6 6 0 0 1 8 2z"/>
        <path d="M8.93 4.588a.5.5 0 0 0-.93 0v.1a.5.5 0 0 0 .93 0v-.1zM8.25 6a.25.25 0 0 0-.25.25v4.5a.25.25 0 0 0 .25.25h.5a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25h-.5z"/>
      </svg>
      <div class="tooltip-text">
      ${vPasswordConst.PASS_DESCRIPTION}
      </div>
    </span>
  </label>
  <input type="password" id="password" class="swal2-input" placeholder="Contraseña" autocomplete="new-password">
</div>

<div style="margin-bottom: 10px;">
  <label for="confirmPassword" style="display: block; text-align: left;">
    Confirmar Contraseña
  </label>
  <input type="password" id="confirmPassword" class="swal2-input" placeholder="Confirmar contraseña" autocomplete="new-password">
</div>

<div id="validationMessage" class="swal2-validation-message" style="display: none;"></div>
      `
}